import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../../../../components/link/Anchor';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';

const OpenBrandProductList = (props) => {
  const { text, storeId, productStatusList, toggleModal } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) || isNil(storeId) || !toggleModal) {
    return '-';
  }

  return (
    <Anchor
      color="primary"
      isUnderLine
      text={text}
      onClick={() =>
        toggleModal({
          name: 'brandProductListModal',
          value: true,
          data: {
            listData: {
              list: [],
              pagination: LIST_PAGINATION_MODEL,
            },
            storeId,
            productStatusList,
          },
        })
      }
    />
  );
};

export default OpenBrandProductList;
